import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { batch, useDispatch } from 'react-redux';

import Card from '../../../../components/Card/Card';
import Text from '../../../../components/Text/Text';
import Table from '../../../../components/Table/Table';
import TableHeadData from '../../../../components/Table/TableHeadData';
import TableRow from '../../../../components/Table/TableRow';
import TableHead from '../../../../components/Table/TableHead';
import TableBody from '../../../../components/Table/TableBody';
import RoleUserRow from './RoleUserRow';
import EmptyTable from '../../../../components/Table/EmptyTable';
import PermissionsGate from '../../../../components/PermissionsGate/PermissionsGate';
import { permissions } from '../../../../common/permissionGroup';
import ChangeUserRoleModal from '../../../../components/ChangeUserRoleModal/ChangeUserRoleModal';
import patchUserData from '../../../../thunks/users/patchUserData';
import accountStatus from '../../../../constants/accountStatus';
import getRoleDetails from '../../../../thunks/roles/getRoleDetails';

const headerClassName = 'flex flex-row';
const titleClassName = 'text-[17px] pr-[5px]';
const countClassName = 'text-[14px]';
const bodyClassName = 'px-[30px] py-0';

const RoleUsersCard = ({ users }) => {
  const [roleChangeModalVisibility, setRoleChangeModalVisibility] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const dispatch = useDispatch();
  const actionList = [
    {
      id: 1,
      title: 'Change role',
      onClick: (item) => {
        setSelectedUser(item);
        setRoleChangeModalVisibility(true);
      }
    },
    {
      id: 2,
      title: 'Block user',
      onClick: ({ id, role_id: roleId }) => {
        batch(() => {
          dispatch(patchUserData({ userId: id, account_status: accountStatus.DISABLED }));
          dispatch(getRoleDetails(roleId));
        });
      },
      danger: true
    },
    {
      id: 3,
      title: 'Activate user',
      onClick: ({ id, role_id: roleId }) => {
        batch(() => {
          dispatch(patchUserData({ userId: id, account_status: accountStatus.ACTIVE }));
          dispatch(getRoleDetails(roleId));
        });
      },
    },
  ];
  return (
    <Card
      showHeader
      headerBordered={false}
      headerLeft={(
        <div className={headerClassName}>
          <Text text="Users Assigned" bold textStyle={titleClassName} />
          <Text text={`(${users?.length})`} muted textStyle={countClassName} bold />
        </div>
    )}
      styleBodyContainer={bodyClassName}
    >
      <div>
        <Table>
          <TableHead>
            <TableRow bordered>
              <TableHeadData>
                id
              </TableHeadData>
              <TableHeadData>
                user
              </TableHeadData>
              <TableHeadData>
                login
              </TableHeadData>
              <TableHeadData>
                status
              </TableHeadData>
              <TableHeadData>
                Joined Date
              </TableHeadData>
              <TableHeadData>
                <PermissionsGate can={permissions.ADMIN_ADMIN}>
                  Action
                </PermissionsGate>
              </TableHeadData>
            </TableRow>
          </TableHead>
          <TableBody>
            {users?.length ? users?.map((user) => (
              <RoleUserRow user={user} actionList={actionList} key={user.id} />
            )) : <EmptyTable colSpan={5} text="No any users connected" />}
          </TableBody>
        </Table>
      </div>
      <ChangeUserRoleModal
        visible={roleChangeModalVisibility}
        toggleVisible={() => setRoleChangeModalVisibility(false)}
        currentRoleId={selectedUser?.role_id}
        userId={selectedUser?.id}
      />
    </Card>
  );
};

RoleUsersCard.propTypes = {
  users: PropTypes.arrayOf(PropTypes.shape({}))
};

RoleUsersCard.defaultProps = {
  users: []
};

export default RoleUsersCard;
